<ng-container>
  <h3 class="titleHeader stickyHead"></h3>
  <div class="wrapper">
    <div class="wrapperExpansion">
      <mat-card>
        <div class="wrapper">
          <div class="innerWrapper hotelBookingStatus">
            <p class="location"><img class="img-fluid"></p>
            <h3></h3>
            <div class="searchPropertyDetials d-flex">
              <div class="inner">
                <p>
                  <mat-icon color="primary"></mat-icon>&nbsp;
                </p>
                <p>
                  <mat-icon color="primary"></mat-icon>&nbsp;
                </p>
              </div>
              <div class="inner">
                <p>&nbsp;<span></span></p>
                <p>&nbsp;<span></span></p>
              </div>
            </div>
            <div class="travelInfo">
              <h3></h3>
              <p><span></span>&nbsp;&nbsp;<span> </span></p>
            </div>
          </div>
          <div class="innerWrapper">
            <div class="imgWrapper">
              <img alt="" class="img-fluid">
              <ng-container>
                <ng-container>
                  <img [src]="" class="img-fluid">
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </mat-card>
      <mat-card class="travell_tab">
        <h3></h3>
        <button></button>
      </mat-card>
      <mat-card class="travellForm"></mat-card>
    </div>
    <app-hotel-summary-loader></app-hotel-summary-loader>
  </div>
</ng-container>
